import React from "react";
import "./Academia.css";
import { FaNetworkWired, FaHeartbeat, FaTerminal} from "react-icons/fa";

const Features = () => {
   const points = [
      {
         title: "CAOS TÉCNICO",
         desc: "¿Estás perdido entre tantas marcas, protocolos y piezas compatibles? La complejidad del FPV no debería frenar tu pasión por volar.",
         icon: <FaNetworkWired />, 
      },
      {
         title: "MIEDO A ROMPER",
         desc: "¿Te da pánico que tu inversión de 600€ termine estrellada en el mar a los 10 segundos? El riesgo financiero es la barrera número uno.",
         icon: <FaHeartbeat />,
      },
      {
         title: "CÓDIGO IMPOSIBLE",
         desc: "¿Llevas horas en YouTube y Betaflight sigue pareciendo lenguaje de la NASA? Configurar no debería ser un trabajo de ingeniería.",
         icon: <FaTerminal />,
      },
   ];

   return (
      <section className="features-section" id="start">
         <div className="frustrado-header">
            <h2 className="frustrado-title">¿FRUSTRADO?</h2>
            <p className="frustrado-subtitle">
               Sé lo que se siente al intentar despegar y encontrarse con
               un muro de tecnicismos y costes elevados.
            </p>
         </div>

         <div className="cards-container">
            {points.map((item, index) => (
               <div className="features-card" key={index}>
                  <div className="features-card-icon">{item.icon}</div>
                  <h3 className="features-card-title">{item.title}</h3>
                  <p className="features-card-desc">{item.desc}</p>
               </div>
            ))}
         </div>
      </section>
   );
};

export default Features;
